import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { CreateUserActivityParams } from '../UserActivityTypes';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { USER_ACTIVITY_QUERY_KEY } from './useActivities';

const createUserActivity = async ({ clientId, activity }: CreateUserActivityParams) => {
  return authFetch(`/Consumer/ActivityLog/SaveActivity?clientId=${clientId}`, {
    method: 'POST',
    ...httpBodyOptions(activity, true),
  });
};

export const useCreateUserActivity = () => {
  const queryClient = useQueryClient();

  return useMutation(createUserActivity, {
    onSuccess(_, { clientId }) {
      queryClient.invalidateQueries([USER_ACTIVITY_QUERY_KEY, clientId]);
    },
  });
};
